import React, { useState, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Accordion } from "@zendeskgarden/react-accordions"
import ArrowIcon from "@zendeskgarden/svg-icons/src/12/chevron-right-stroke.svg"
import { GlobalContext } from "../../lib/context/globalContextProvider"

const StyledAccordionPanel = styled(Accordion.Panel)`
  margin: ${props => `0 -${props.theme.space.xs}`};
  border-top: ${props =>
    `${props.theme.borders.sm} ${props.theme.colors.sidebar.accordionTopBorder} !important`};
`

const StyledAccordionHeader = styled(Accordion.Header)`
  padding: ${props => `0 ${props.theme.space.base}px`};
`

const AccordionPanelContentsWrapper = styled.div`
  padding-top: ${props => props.theme.space.lg};
`

const StyledAccordionLabel = styled(Accordion.Label)`
  color: ${props => props.theme.colors.sidebar.breadcrumbs};
`

const StyledArrowIcon = styled(ArrowIcon)`
  margin: 0 ${props => props.theme.space.xxs};
`

const SidebarAccordion = ({ breadcrumbs, children }) => {
  const [expanded, setExpanded] = useState(false)
  const { sidebarContentsVisible } = useContext(GlobalContext)

  useEffect(() => {
    sidebarContentsVisible.set(expanded)

    return () => {
      sidebarContentsVisible.set(true)
    }
  }, [])

  return (
    <Accordion
      level={4}
      expandedSections={expanded ? [0] : []}
      onChange={() => {
        sidebarContentsVisible.set(!expanded)
        return setExpanded(!expanded)
      }}
    >
      <Accordion.Section>
        <StyledAccordionHeader>
          <StyledAccordionLabel data-testid="dev-docs-sidebar-accordion-label">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={crumb}>
                {crumb}
                {index !== breadcrumbs.length - 1 && <StyledArrowIcon />}
              </React.Fragment>
            ))}
          </StyledAccordionLabel>
        </StyledAccordionHeader>
        <StyledAccordionPanel data-testid="dev-docs-sidebar-accordion-panel">
          {expanded && (
            <AccordionPanelContentsWrapper>
              {children}
            </AccordionPanelContentsWrapper>
          )}
        </StyledAccordionPanel>
      </Accordion.Section>
    </Accordion>
  )
}

SidebarAccordion.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired
}

export default SidebarAccordion
